/**
 * Normalização de rastreios bipados em coletor.
 *
 * O backend do SantoLog espera rastreios no formato canônico:
 *
 *   ALEF{NOTA_FISCAL}V{VOLUME}    ex: ALEF642141V1
 *
 * As transportadoras começaram a imprimir etiquetas com prefixos próprios
 * (SLEXPRESSO, SLRAPIDO, TMRAPIDO, TMEXPRESSO, ...). O padrão dos dígitos
 * NF+V+Volume continua igual — só o prefixo textual muda.
 *
 * Este helper detecta o formato NF+V{N} em qualquer parte da string e
 * reescreve o rastreio para o formato ALEF. Assim, o resto do código
 * (chamadas à API, cache, histórico) continua funcionando sem mudança.
 *
 * Exemplos:
 *   normalizeRastreio('ALEF642141V1')        → 'ALEF642141V1'
 *   normalizeRastreio('SLEXPRESSO642141V1')  → 'ALEF642141V1'
 *   normalizeRastreio('SLRAPIDO642141V3')    → 'ALEF642141V3'
 *   normalizeRastreio('TMRAPIDO789012V2')    → 'ALEF789012V2'
 *   normalizeRastreio('TMEXPRESSO88V4')      → 'ALEF88V4'
 *   normalizeRastreio('  alef642141v1  ')    → 'ALEF642141V1'  (trim + upcase)
 *   normalizeRastreio('EE12345')             → 'EE12345'       (formato desconhecido — passa cru)
 *   normalizeRastreio('')                    → ''
 *   normalizeRastreio(null)                  → null
 */
export function normalizeRastreio(raw) {
  if (raw == null) return raw
  const s = String(raw).trim().toUpperCase()
  if (!s) return s
  // Extrai NF (grupo de dígitos antes de V+dígito) e Volume (V+dígitos no fim)
  const nfMatch = s.match(/(\d+)(?=V\d)/i)
  const volMatch = s.match(/V(\d+)\s*$/i)
  if (nfMatch && volMatch) {
    return `ALEF${nfMatch[1]}V${volMatch[1]}`
  }
  // Formato desconhecido — devolve o input como veio (deixa o backend decidir)
  return s
}

/**
 * Aplica normalizeRastreio em uma lista, filtrando vazios/duplicados.
 * Útil pro batch da Devolução.
 */
export function normalizeRastreios(list) {
  if (!Array.isArray(list)) return []
  const seen = new Set()
  const out = []
  for (const r of list) {
    const n = normalizeRastreio(r)
    if (!n) continue
    if (seen.has(n)) continue
    seen.add(n)
    out.push(n)
  }
  return out
}
